export function pemToArrayBuffer(pem: string): ArrayBuffer {
  const b64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/, "")
    .replace(/-----END PUBLIC KEY-----/, "")
    .replace(/\s/g, "");
  const binaryString = globalThis.atob(b64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return globalThis.btoa(binary);
}

type Attribute = {
  Name: string;
  Value: string;
};

type ParsedValue = string | number | boolean | null | object | unknown[];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseJsonProps = (obj: unknown): any => {
  if (Array.isArray(obj)) return obj.map(parseJsonProps);
  if (obj && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, val]) => {
        if (typeof val === "string") {
          try {
            const parsed = JSON.parse(val);
            return [
              key,
              typeof parsed === "object" && parsed !== null
                ? parseJsonProps(parsed)
                : val,
            ];
          } catch {
            return [key, val];
          }
        }
        return [key, parseJsonProps(val)];
      }),
    );
  }
  return obj;
};

export const parseAttributeListToObject = (
  list: Attribute[],
): Record<string, ParsedValue> =>
  Object.fromEntries(
    list.map(({ Name, Value }) => {
      let parsed: ParsedValue;
      try {
        parsed = JSON.parse(Value);
        if (typeof parsed === "object" && parsed !== null) {
          parsed = parseJsonProps(parsed);
        } else {
          parsed = Value;
        }
      } catch {
        parsed = Value;
      }
      return [Name.replace(/^custom:/, ""), parsed];
    }),
  );
